'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var PropTypes = _interopDefault(require('prop-types'));
var finalForm = require('final-form');

//      
var warning = process.env.NODE_ENV === 'production' ? /* istanbul ignore next */
function (condition, message) {} : function (condition, message) {
  if (!condition) {
    console.error('Warning: ' + message);
  }
};

//      
function diffSubscription (a, b, keys) {
  if (a) {
    if (b) {
      // $FlowFixMe
      return keys.some(function (key) {
        return a[key] !== b[key];
      });
    } else {
      return true;
    }
  } else {
    return !!b;
  }
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

//      

// shared logic between components that use either render prop,
// children render function, or component prop
function renderComponent(props, name) {
  var render = props.render,
      children = props.children,
      component = props.component,
      rest = objectWithoutProperties(props, ['render', 'children', 'component']);

  if (component) {
    return React.createElement(component, _extends({}, rest, { children: children })); // inject children back in
  }
  if (render) {
    return render(_extends({}, rest, { children: children })); // inject children back in
  }
  if (typeof children !== 'function') {
    warning(false, 'Must specify either a render prop, a render function as children, or a component prop to ' + name);
    return null; // warning will alert developer to their mistake
  }
  return children(rest);
}

//      

var all = finalForm.fieldSubscriptionItems.reduce(function (result, key) {
  result[key] = true;
  return result;
}, {});

var FieldArray$$1 = function (_React$PureComponent) {
  inherits(FieldArray$$1, _React$PureComponent);

  function FieldArray$$1(props, context) {
    classCallCheck(this, FieldArray$$1);

    var _this = possibleConstructorReturn(this, (FieldArray$$1.__proto__ || Object.getPrototypeOf(FieldArray$$1)).call(this, props, context));

    _initialiseProps.call(_this);

    var initialState = void 0;
    warning(context.reactFinalForm, 'FieldArray must be used inside of a ReactFinalForm component');
    var reactFinalForm = _this.context.reactFinalForm;

    if (reactFinalForm) {
      // avoid error, warning will alert developer to their mistake
      _this.subscribe(props, function (state) {
        if (initialState) {
          _this.notify(state);
        } else {
          initialState = state;
        }
      });
    }
    _this.state = { state: initialState || {} };
    _this.bindMutators(props);
    _this.mounted = false;
    return _this;
  }

  createClass(FieldArray$$1, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var name = nextProps.name,
          subscription = nextProps.subscription;

      if (this.props.name !== name || diffSubscription(this.props.subscription, subscription, finalForm.fieldSubscriptionItems)) {
        if (this.context.reactFinalForm) {
          // avoid error, warning will alert developer to their mistake
          this.unsubscribe();
          this.subscribe(nextProps, this.notify);
        }
      }
      if (this.props.name !== name) {
        this.bindMutators(nextProps);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mounted = true;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mounted = false;
      this.unsubscribe();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          name = _props.name,
          rest = objectWithoutProperties(_props, ['name']);
      var _state$state = this.state.state,
          length = _state$state.length,
          active = _state$state.active,
          dirty = _state$state.dirty,
          error = _state$state.error,
          initial = _state$state.initial,
          invalid = _state$state.invalid,
          pristine = _state$state.pristine,
          submitError = _state$state.submitError,
          submitFailed = _state$state.submitFailed,
          submitSucceeded = _state$state.submitSucceeded,
          touched = _state$state.touched,
          valid = _state$state.valid,
          visited = _state$state.visited,
          fieldStateFunctions = objectWithoutProperties(_state$state, ['length', 'active', 'dirty', 'error', 'initial', 'invalid', 'pristine', 'submitError', 'submitFailed', 'submitSucceeded', 'touched', 'valid', 'visited']);

      var meta = {
        active: active,
        dirty: dirty,
        error: error,
        initial: initial,
        invalid: invalid,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        touched: touched,
        valid: valid,
        visited: visited
      };
      var fieldState = _extends({}, meta, fieldStateFunctions);
      return renderComponent(_extends({
        fields: _extends({
          name: name,
          forEach: this.forEach,
          length: length,
          map: this.map
        }, this.mutators, fieldState),
        meta: meta
      }, rest), 'FieldArray(' + name + ')');
    }
  }]);
  return FieldArray$$1;
}(React.PureComponent);

FieldArray$$1.displayName = 'ReactFinalFormFieldArray(' + finalForm.version + ')(' + version + ')';

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.subscribe = function (_ref, listener) {
    var name = _ref.name,
        subscription = _ref.subscription;

    _this2.unsubscribe = _this2.context.reactFinalForm.registerField(name, listener, subscription ? _extends({}, subscription, { length: true }) : all, {
      getValidator: function getValidator() {
        return _this2.props.validate;
      }
    });
  };

  this.bindMutators = function (_ref2) {
    var name = _ref2.name;
    var reactFinalForm = _this2.context.reactFinalForm;

    if (reactFinalForm) {
      var mutators = reactFinalForm.mutators;

      var hasMutators = !!(mutators && mutators.push && mutators.pop);
      warning(hasMutators, 'Array mutators not found. You need to provide the mutators from final-form-arrays to your form');
      if (hasMutators) {
        _this2.mutators = Object.keys(mutators).reduce(function (result, key) {
          result[key] = function () {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            return mutators[key].apply(mutators, [name].concat(args));
          };
          return result;
        }, {});
      }
    }
  };

  this.notify = function (state) {
    setTimeout(function () {
      if (_this2.mounted) {
        _this2.setState({ state: state });
      }
    });
  };

  this.forEach = function (iterator) {
    var name = _this2.props.name;
    var length = _this2.state.state.length;

    for (var i = 0; i < length; i++) {
      iterator(name + '[' + i + ']', i);
    }
  };

  this.map = function (iterator) {
    var name = _this2.props.name;
    var length = _this2.state.state.length;

    var results = [];
    for (var i = 0; i < length; i++) {
      results.push(iterator(name + '[' + i + ']', i));
    }
    return results;
  };
};


FieldArray$$1.contextTypes = {
  reactFinalForm: PropTypes.object
};

//      

var version = '1.0.3';

exports.version = version;
exports.FieldArray = FieldArray$$1;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-final-form-arrays/dist/react-final-form-arrays.cjs.js
 ** module id = 203
 ** module chunks = 0
 **/